import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ff007398"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "currency" }
const _hoisted_2 = {
  key: 0,
  class: "left-loading"
}
const _hoisted_3 = {
  key: 1,
  class: "currency-left"
}
const _hoisted_4 = { class: "part-1" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "doc" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "请选择兑换方向", -1))
const _hoisted_8 = { class: "select" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "客户账号：", -1))
const _hoisted_10 = { class: "select-type" }
const _hoisted_11 = { class: "cash-out" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "down-icon" }, null, -1))
const _hoisted_13 = {
  key: 1,
  class: "list"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "cash-in" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "down-icon" }, null, -1))
const _hoisted_17 = {
  key: 1,
  class: "list"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "part-2" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("i"),
  /*#__PURE__*/_createElementVNode("span", { class: "text" }, "兑出")
], -1))
const _hoisted_21 = { class: "money" }
const _hoisted_22 = { class: "money-type" }
const _hoisted_23 = { class: "input" }
const _hoisted_24 = { class: "level" }
const _hoisted_25 = { class: "usable-money" }
const _hoisted_26 = { class: "tips" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "可兑换金额", -1))
const _hoisted_28 = { class: "part-3" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("i", { style: {"width":"88px"} }),
  /*#__PURE__*/_createElementVNode("span", { class: "text" }, "预计兑入")
], -1))
const _hoisted_30 = { class: "money" }
const _hoisted_31 = { class: "money-type" }
const _hoisted_32 = { class: "input" }
const _hoisted_33 = { class: "level" }
const _hoisted_34 = { class: "usable-money" }
const _hoisted_35 = {
  key: 0,
  class: "tips"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "参考汇率", -1))
const _hoisted_37 = { class: "btn-wrap" }
const _hoisted_38 = { class: "record" }
const _hoisted_39 = {
  key: 2,
  class: "right-loading"
}
const _hoisted_40 = {
  key: 3,
  class: "right"
}
const _hoisted_41 = { class: "date" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "选择日期：", -1))
const _hoisted_43 = { class: "table" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tips" }, [
  /*#__PURE__*/_createElementVNode("span", null, "*"),
  /*#__PURE__*/_createTextVNode("数据仅供参考，具体价格以实际成交为准")
], -1))
const _hoisted_45 = {
  key: 0,
  class: "pwdError"
}
const _hoisted_46 = { class: "dialog-footer" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("i"),
  /*#__PURE__*/_createElementVNode("span", null, "本人知悉及确认")
], -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
  /*#__PURE__*/_createElementVNode("p", null, "1.汇率仅供参考，实际的兑换汇率会以交易当时汇率为准。"),
  /*#__PURE__*/_createElementVNode("p", null, " 2.「可兑换金额」仅供参考，此金额有可能包括本人仍未交收的款项。若将「可兑换金额」全数兑换，账户日后可能会出现结欠及需支付利息。 "),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("span", null, " 3.若有任何疑问，请联系客户服务部("),
    /*#__PURE__*/_createElementVNode("span", { class: "email" }, "cs@igoldhorse.com"),
    /*#__PURE__*/_createElementVNode("span", null, ")查询。 ")
  ])
], -1))
const _hoisted_49 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.leftLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_el_skeleton, {
            rows: 5,
            animated: ""
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("i", {
                  onClick: _cache[0] || (_cache[0] = () => _ctx.tipsDialog = true)
                })
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_el_select, {
                  modelValue: _ctx.accountActive,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.accountActive) = $event)),
                  class: "m-2",
                  placeholder: "Select",
                  size: "large",
                  onChange: _ctx.refGetData
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                (_ctx.cashInfo.isShowCashOut === true)
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 0,
                      class: "bg",
                      onClick: _cache[2] || (_cache[2] = () => _ctx.cashInfo.isShowCashOut = false)
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "type",
                  onClick: _cache[3] || (_cache[3] = () => _ctx.cashInfo.isShowCashOut = true)
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(`${_ctx.cashOutItem.icon}-icon`)
                  }, null, 2),
                  _createElementVNode("div", null, _toDisplayString(_ctx.cashOutItem.name), 1),
                  _createElementVNode("div", null, _toDisplayString(_ctx.cashOutItem.value), 1),
                  _hoisted_12
                ]),
                (_ctx.cashInfo.isShowCashOut)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cashOutList, (item, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "item",
                          key: idx,
                          onClick: ($event: any) => (_ctx.cashOutClick(item))
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(`${item.icon}-icon`)
                          }, null, 2),
                          _createElementVNode("div", null, _toDisplayString(item.name), 1),
                          _createElementVNode("div", null, _toDisplayString(item.value), 1)
                        ], 8, _hoisted_14))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: "change-icon",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.exchangeTypeClick && _ctx.exchangeTypeClick(...args)))
              }),
              _createElementVNode("div", _hoisted_15, [
                (_ctx.cashInfo.isShowCashIn === true)
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 0,
                      class: "bg",
                      onClick: _cache[5] || (_cache[5] = () => _ctx.cashInfo.isShowCashIn = false)
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "type",
                  onClick: _cache[6] || (_cache[6] = () => _ctx.cashInfo.isShowCashIn = true)
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(`${_ctx.cashInItem.icon}-icon`)
                  }, null, 2),
                  _createElementVNode("div", null, _toDisplayString(_ctx.cashInItem.name), 1),
                  _createElementVNode("div", null, _toDisplayString(_ctx.cashInItem.value), 1),
                  _hoisted_16
                ]),
                (_ctx.cashInfo.isShowCashIn)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cashInList, (item, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "item",
                          key: idx,
                          onClick: ($event: any) => (_ctx.cashInClick(item))
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(`${item.icon}-icon`)
                          }, null, 2),
                          _createElementVNode("div", null, _toDisplayString(item.name), 1),
                          _createElementVNode("div", null, _toDisplayString(item.value), 1)
                        ], 8, _hoisted_18))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.cashOutItem.value), 1),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.cashInfo.outMoneyLevel), 1),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.cashInfo.outValue,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.cashInfo.outValue) = $event)),
                  placeholder: _ctx.cashInfo.outPlaceholder,
                  onInput: _ctx.cashOutInputValueChange,
                  onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.cashBlur(_ctx.ChangeType.OUT)))
                }, null, 8, ["modelValue", "placeholder", "onInput"])
              ]),
              _createElementVNode("div", {
                class: "all",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.cashOutInputValueChange(_ctx.cashInfo.balanceValue)))
              }, "全部兑换")
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.cashInfo.errorTips), 1),
              _hoisted_27,
              _createElementVNode("span", null, _toDisplayString(_ctx.cashInfo.balanceLabel), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.cashInItem.value), 1),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.cashInfo.inMoneyLevel), 1),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.cashInfo.inValue,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.cashInfo.inValue) = $event)),
                  placeholder: "兑入结果",
                  onInput: _ctx.cashInInputValueChange,
                  onBlur: _cache[11] || (_cache[11] = ($event: any) => (_ctx.cashBlur(_ctx.ChangeType.IN)))
                }, null, 8, ["modelValue", "onInput"])
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              (_ctx.cashInfo.outErrorTips)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.cashInfo.outErrorTips), 1),
                    _createElementVNode("div", {
                      class: "all",
                      onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.clickAllOutValue && _ctx.clickAllOutValue(...args)))
                    }, _toDisplayString(_ctx.cashInfo.outErrorAllTips), 1)
                  ]))
                : _createCommentVNode("", true),
              _hoisted_36,
              _createElementVNode("span", null, _toDisplayString(_ctx.foreignList.rateLabel), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", {
              class: _normalizeClass([_ctx.btnDisabled ? 'btn-text' : 'btn-text disable']),
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.applyClick && _ctx.applyClick(...args)))
            }, _toDisplayString(_ctx.cashInfo.btnText), 3),
            _createElementVNode("div", _hoisted_38, [
              _createVNode(_component_router_link, { to: "/currency/record" }, {
                default: _withCtx(() => [
                  _createTextVNode("查看兑换记录")
                ]),
                _: 1
              })
            ])
          ])
        ])),
    (_ctx.rightLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
          _createVNode(_component_el_skeleton, {
            rows: 5,
            animated: ""
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _hoisted_42,
            _createVNode(_component_el_date_picker, {
              modelValue: _ctx.date,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.date) = $event)),
              type: "date",
              placeholder: "Pick a day",
              "disabled-date": _ctx.disabledDate,
              onChange: _ctx.dateChange
            }, null, 8, ["modelValue", "disabled-date", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createVNode(_component_el_table, {
              data: _ctx.tableData,
              style: {"width":"100%"},
              "header-cell-style": { background: '#f7f7f9', color: '#0F1423' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, { label: "货币对" }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", null, _toDisplayString(scope.row.sourceCurrencyDisplay) + "/", 1),
                      _createElementVNode("span", null, _toDisplayString(scope.row.exchangeCurrencyDisplay), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("span", null, _toDisplayString(scope.row.sourceCurrency) + "/", 1),
                      _createElementVNode("span", null, _toDisplayString(scope.row.exchangeCurrency), 1)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "bid",
                  label: "客户卖出价"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "ask",
                  label: "客户买入价"
                }),
                _createVNode(_component_el_table_column, { label: "涨跌幅" }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(scope.row.color)
                      }, _toDisplayString(scope.row.changePct), 3)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"]),
            _hoisted_44
          ])
        ])),
    _createVNode(_component_el_dialog, {
      "custom-class": "pwdDialog",
      modelValue: _ctx.passwordInfo.centerDialogVisible,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.passwordInfo.centerDialogVisible) = $event)),
      title: "请输入登录密码",
      "show-close": false,
      width: "500px",
      "align-center": "",
      center: ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_46, [
          _createVNode(_component_el_button, {
            class: "cancel",
            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.passwordInfo.centerDialogVisible = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            class: "sure",
            onClick: _ctx.checkPwd,
            loading: _ctx.pwdLoading || _ctx.submitLoading
          }, {
            default: _withCtx(() => [
              _createTextVNode("确定")
            ]),
            _: 1
          }, 8, ["onClick", "loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: _ctx.passwordInfo.password,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.passwordInfo.password) = $event)),
          type: "password",
          placeholder: "请输入登录密码",
          "show-password": "",
          onInput: _cache[16] || (_cache[16] = () => _ctx.passwordInfo.errorTips = '')
        }, null, 8, ["modelValue"]),
        (_ctx.passwordInfo.errorTips)
          ? (_openBlock(), _createElementBlock("p", _hoisted_45, _toDisplayString(_ctx.passwordInfo.errorTips), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      "custom-class": "tipsDialog",
      modelValue: _ctx.tipsDialog,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.tipsDialog) = $event)),
      "show-close": false,
      width: "500px",
      "align-center": "",
      center: ""
    }, {
      title: _withCtx(() => [
        _hoisted_47
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_49, [
          _createVNode(_component_el_button, {
            class: "cancel",
            onClick: _cache[19] || (_cache[19] = () => _ctx.tipsDialog = false)
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            class: "sure",
            onClick: _cache[20] || (_cache[20] = () => _ctx.tipsDialog = false)
          }, {
            default: _withCtx(() => [
              _createTextVNode("确定")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_48
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}